// 创建人：bai.zhiming
// 创建时间：2016-9-23
// 描述：编辑图片服务
'use strict';
angular
    .module('editPictureServiceModule', [
        'editPictureModule',
        'trsCutPictureCtrlMoudle',
        'newCropperModule',
        'newCropperPreviewModule',
        'newCropperAppModule',
    ])
    .factory('editPictureService', [
        '$modal',
        '$q',
        '$state',
        'trsHttpService',
        'modalDialog',
        'trsEditImgService',
        function($modal, $q, $state, trsHttpService, modalDialog, trsEditImgService) {
            var loadWatermark;

            /**
             * [dataURLtoBlob description]
             *
             * @param   {[type]}  dataurl  [dataurl description]
             *
             * @return  {[type]}           [return description]
             */
            function dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime,
                });
            }

            /**
             * [getFileName description]
             *
             * @param   {[type]}  imgSrc  [imgSrc description]
             *
             * @return  {[type]}          [return description]
             */
            function getFileName(imgSrc) {
                var fileName;
                var imgSrcArray;
                if (imgSrc.indexOf('FileName=') > 0) {
                    let arr = imgSrc.match(/FileName=(.*)/gi);
                    if (arr[0] !== '') {
                        fileName = arr[0].split('&');
                        fileName = fileName[0];
                        fileName = fileName.split('=')[1];
                    }
                    return fileName;
                }
                var isInJsp = !!(imgSrc.indexOf('read_image.jsp') > 0 || imgSrc.indexOf('readimg?') > 0);
                if (!isInJsp) {
                    imgSrcArray = imgSrc.split('/');
                    fileName = imgSrcArray[imgSrcArray.length - 1];
                } else {
                    imgSrcArray = imgSrc.split('=');
                    fileName = imgSrcArray[1];
                }
                return fileName;
            }

            /**
             * [submitDatabase64Url description]提交database64图片数据
             * 
             * @param   {[type]}  databaseUrl  [imgSrc description]
             * 
             * @return {[string]}  图片地址 [description] 图片返回信息
             */
            function submitDatabase64Url(databaseUrl) {
                var imgType = getImageType(databaseUrl);
                var deffer = $q.defer();
                var blob = dataURLtoBlob(databaseUrl);
                var fd = new FormData();
                fd.append('image', blob, 'image.' + imgType);
                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/wcm/openapi/uploadImage', true);
                xhr.send(fd);
                var data;
                xhr.onreadystatechange = function() {
                    try {
                        data = xhr.responseText;
                        if (data !== '' && data !== undefined) {
                            return deffer.resolve(JSON.parse(data));
                        } else {
                            deffer.reject(JSON.parse(data));
                        }
                    } catch (e) {}
                };
                return deffer.promise;
            }

            /**
             * [getFolderext description]获取目录类型
             * @param  {[string]} fileName [description] 图片名称
             * @return {[string]}  folderext [description] 返回目录类型
             */
            function getFolderext(fileName) {
                return fileName.indexOf('U0') === 0 ? 'U0' : 'W0';
            }

            /**
             * [cutPicture description]根据图片地址判断图片类型
             * @param  {[string]} src [description] 图片路径
             * @return {[string]}  type [description] 返回图片类型
             */
            function getImageType(src) {
                var typeMap = {
                    jpg: 'jpeg',
                    png: 'png',
                    bmp: 'bmp',
                    gif: 'gif',
                    jpeg: 'jpeg',
                };
                var switchSrc = src.toLowerCase();
                var imgType = 'jpeg';
                for (var j in typeMap) {
                    if (switchSrc.indexOf('.' + j) > 0 || switchSrc.indexOf('image/' + j) > 0) {
                        imgType = typeMap[j];
                        break;
                    }
                }
                return imgType;
            }

            /**
             * [dealAfterImg description]对比gif图比例是否和预设比例相符，获得图片对象后的处理逻辑
             *
             * @param  {[type]}  img   [img description]
             * @param  {[type]}  imgAspectRatio   [imgAspectRatio description]
             * @param  {[type]}  type   [type description]
             * @param  {[type]}  defer   [defer description]
             *
             * @return  {[type]}   [return description]
             */
            function dealAfterImg(img, imgAspectRatio, type, defer) {
                var imgSize = (img.width / img.height).toFixed(2);
                if (imgAspectRatio - 0.1 > imgSize || imgAspectRatio + 0.1 < imgSize) {
                    modalDialog.alertType('', 'GIF格式图片不支持编辑，当前图片比例与预设比例不同，设为' + type + '会出现变形，是否确定继续？', 'warning', true, function() {
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
            }
            return {

                /**
                 * [cutPicture description]图片裁剪
                 * 
                 * @param  {[string]} src [description] 图片路径
                 * @param  {[string]} picturesize [description] 图片剪裁框大小
                 * @param  {[string]} success [description]
                 * @param  {[string]} cancel [description]
                 * 
                 * @return {[FN]}  success [description] 回调函数 返回处理好的图片路径
                 */
                cutPicture: function(src, picturesize, success, cancel) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/editPicture/trsCutPicture/template/trsCutPicture_tpl.html',
                        windowClass: 'cutOut',
                        backdrop: false,
                        controller: 'cutPictureCtrl',
                        resolve: {
                            params: function() {
                                var params = {
                                    src: src,
                                    picturesize: picturesize,
                                };
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        if (result && angular.isFunction(success)) {
                            success(result);
                        } else if (!result && angular.isFunction(cancel)) {
                            cancel();
                        }
                    });
                },

                /**
                 * [editPicture description]编辑图片
                 * 
                 * @param  {[string]} image [description] 图片路径
                 * @param  {[string]} siteId [description] 图片剪裁框大小
                 * @param {[string]} success [description] 站点ID
                 * 
                 * @return {[FN]}  success [description] 回调函数 返回处理好的图片路径
                 */
                editPicture: function(image, siteId, success) {
                    // var modalInstance = $modal.open({
                    //     templateUrl: './components/service/editPicture/editPicture_tpl.html',
                    //     windowClass: 'editPictures',
                    //     backdrop: false,
                    //     controller: 'editPictureCtrl',
                    //     resolve: {
                    //         params: function() {
                    //             var params = {
                    //                 image: image,
                    //                 siteId: siteId,
                    //             };
                    //             return params;
                    //         },
                    //     },
                    // });
                    // modalInstance.result.then(function(result) {
                    //     if (angular.isFunction(success)) {
                    //         success(result);
                    //     }
                    // });
                    trsEditImgService.editImg({
                        image: image,
                        siteId: siteId,
                    }).then((result) => {
                        if (angular.isFunction(success)) {
                            success(result);
                        }
                    });
                },

                /**
                 * [dataURLtoBlob description]base64转为blob
                 * @param  {[string]} dataurl [description] base64图片路径
                 * @return {[Blob]}  blob对象 [description] 获取blob对象
                 */
                // 将DataUrl 转换成blob
                dataURLtoBlob: function(dataurl) {
                    return dataURLtoBlob(dataurl);
                },

                /**
                 * [compressImg description]压缩图片
                 * 
                 * @param  {[string]} imgSrc [description]
                 * @param  {[string]} width [description] 压缩宽度
                 * @param  {[string]} height [description] 压缩高度
                 * 
                 * @return {[string]}  blob对象 [description] 图片返回信息
                 */
                compressImg: function(imgSrc, width, height) {
                    var deffer = $q.defer();
                    var fileName = getFileName(imgSrc);
                    var folderext = getFolderext(fileName);
                    var params = {
                        serviceid: 'mlf_image',
                        methodname: 'scaleImage',
                        SCALEWIDTH: Math.round(width),
                        SCALEHEIGHT: Math.round(height),
                        FILENAME: fileName,
                        FileUrl: imgSrc,
                        FOLDEREXT: folderext,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        deffer.resolve('/wcm/file/read_image.jsp?FileName=' + data.FN);
                    });
                    return deffer.promise;
                },

                /**
                 * [ScaleWatermark description]缩放水印
                 * @param  {[string]} watermark [description] 水印图片地址
                 * @param  {[string]} width [description] 压缩宽度
                 * @param  {[string]} height [description] 压缩高度
                 * @param  {[float]} opacity [description] 水印透明度
                 * @return {[string]}  url [description] 新的水印图像
                 */
                ScaleWatermark: function(watermark, width, height, opacity) {
                    var imgType = getImageType(watermark);
                    var deffer = $q.defer();
                    var canvas = document.createElement('canvas');
                    var img = new Image();
                    img.src = watermark;
                    img.onload = function() {
                        canvas.width = width;
                        canvas.height = height;
                        var context = canvas.getContext('2d');
                        context.globalAlpha = opacity;
                        context.drawImage(img, 0, 0, width, height);
                        var url = canvas.toDataURL('image/' + imgType);
                        submitDatabase64Url(url).then(function(data) {
                            deffer.resolve(data.imgSrc.replace(/ScaleWidth=600&/g, ''));
                        });
                    };
                    return deffer.promise;
                },

                /**
                 * [submitDatabase64Url description]提交database64图片数据
                 * 
                 * @param  {[string]} databaseUrl [description]
                 * 
                 * @return {[string]}  blob对象 [description] 图片返回信息
                 */
                submitDatabase64Url: function(databaseUrl) {
                    var deffer = $q.defer();
                    submitDatabase64Url(databaseUrl).then(function(data) {
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                },

                /**
                 * [getWatermarkList description]获取水印列表
                 *
                 * @param   {[type]}  siteId     [siteId description]
                 * @param   {[type]}  productId  [productId description]
                 * @param   {[type]}  mediaType  [mediaType description]
                 *
                 * @return  {[type]}             [return description]
                 */
                getWatermarkList: function(siteId, productId, mediaType) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_website',
                        methodname: 'makeWaterMarks',
                        // siteId: siteId,
                        objectid: siteId,
                    };
                    if (!siteId) {
                        params.serviceid = 'mlf_watermark';
                        params.methodname = 'queryWaterMarksInEdit';
                        params.productId = productId;
                        params.mediaType = mediaType;
                        delete params.objectid;
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                },

                /**
                 * [parseFloat description]保留小数点后两位
                 * 
                 * @param {[string]} num [description] 站点ID
                 * 
                 * @return {[float]}  返回的小数 [description]
                 */
                parseFloat: function(num) {
                    var strNum = num + '';
                    if (strNum.indexOf('.') >= 0) {
                        strNum = strNum.substring(0, strNum.indexOf('.') + 3);
                    }
                    return parseFloat(strNum);
                },

                /**
                 * [watermark description]添加水印
                 * @param  {[string]} _orgImg [description] 原图地址
                 * @param  {[string]} watermark [description] 水印地址
                 * @param  {[int]} x [description] 横向坐标
                 * @param {[int]} y [description] 纵向坐标
                 * @param {[int]} opacity [description] 透明度
                 * @return {[string]} url [description] 返回图片地址
                 */
                watermark: function(_orgImg, watermark, x, y, opacity) {
                    var deffer = $q.defer();
                    var orgImg = new Image();
                    orgImg.src = _orgImg;
                    orgImg.onload = function() {
                        var posArray = [4, Math.round(y), Math.round(x), Math.round(orgImg.width), Math.round(orgImg.height)];
                        var params = {
                            WMPOS: posArray.join(','),
                            WMPIC: getFileName(watermark),
                            PIC: getFileName(_orgImg),
                        };
                        trsHttpService.httpServer('/wcm/app/photo/getWaterMark.jsp', params, 'get').then(function(data) {
                            deffer.resolve('/wcm/file/read_image.jsp?FileName=' + data);
                        });
                    };
                    return deffer.promise;

                    /* var imgType = getImageType(orgImg);
                var deffer = $q.defer();
                var img = new Image();
                img.src = orgImg;
                var imgWaterMark = new Image();
                imgWaterMark.src = watermark;
                img.onload = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    ctx.globalAlpha = opacity;
                    setTimeout(function() { //使性能较差的电脑有时间处理图片
                        ctx.drawImage(imgWaterMark, x, y);
                        deffer.resolve(canvas.toDataURL("image/" + imgType));
                    }, 1000);
                    //window.open(canvas.toDataURL("image/png"));
                };
                return deffer.promise;*/
                },

                /**
                 * [newCropper description 裁剪图片new]
                 * @param  {[string]} src [description]
                 * @return {[type]} [description]
                 */
                newCropper: function(src) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/editPicture/newCropper/newCropper_tpl.html',
                        windowClass: 'newCropper',
                        backdrop: false,
                        controller: 'newCropperCtrl',
                        resolve: {
                            params: function() {
                                return {
                                    imgSrc: src,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [newCropperPreview description 预览裁剪图片new]
                 * @param  {[string]} prevImg [description]
                 * @return {[type]} [description]
                 */
                newCropperPreview: function(prevImg) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/editPicture/newCropper/newCropperPreview/newCropperPreview_tpl.html',
                        windowClass: 'newCropperPreview',
                        backdrop: false,
                        controller: 'newCropperPreviewCtrl',
                        resolve: {
                            params: function() {
                                return {
                                    prevImg: prevImg,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [newCropper description 裁剪图片new]
                 * @param {[string]} src [description] 图片路径
                 * @param {[pictureSize]} pictureSize [description] 裁剪尺寸
                 * @return {[type]} [description]
                 */
                newCropperApp: function(src, pictureSize) {
                    var deffer = $q.defer();
                    trsEditImgService.editImg({
                        image: {
                            APPFILE: src.imgName || src,
                            PERPICURL: src.imgSrc || '/wcm/openapi/readimg?FileName=' + src
                        },
                        cropperOption: {
                            size: pictureSize
                        },
                        siteId: $state.params.appsiteid || $state.params.wzsiteid,
                    }).then(
                        function(result) {
                            deffer.resolve(result);
                        },
                        function() {
                            deffer.reject(); // 点击关闭时的回调
                        }
                    );
                    // let imgSrc = src.imgSrc || '/wcm/openapi/readimg?FileName=' + src;
                    // var modalInstance = $modal.open({
                    //     templateUrl: './components/service/editPicture/newCropperApp/newCropperApp_tpl.html',
                    //     windowClass: 'newCropperApp',
                    //     backdrop: false,
                    //     controller: 'newCropperAppCtrl',
                    //     resolve: {
                    //         params: function() {
                    //             return {
                    //                 imgSrc: imgSrc,
                    //                 pictureSize: {
                    //                     width: pictureSize.split(',')[0],
                    //                     height: pictureSize.split(',')[1],
                    //                 },
                    //             };
                    //         },
                    //     },
                    // });
                    // modalInstance.result.then(
                    //     function(result) {
                    //         deffer.resolve(result);
                    //     },
                    //     function() {
                    //         deffer.reject(); // 点击关闭时的回调
                    //     }
                    // );
                    return deffer.promise;
                },

                /**
                 * [cutPicture description]根据图片地址判断图片类型
                 * @param  {[string]} src [description] 图片路径
                 * @return {[string]}  type [description] 返回图片类型
                 */
                getImageType: function(src) {
                    return getImageType(src);
                },

                /**
                 * [getFileName description]获取图片名称
                 * @param  {[string]} src [description] 图片路径
                 * @return {[string]}  type [description] 返回图片名称
                 */
                getFileName: function(src) {
                    return getFileName(src);
                },

                /**
                 * [rotateImage description]旋转图片
                 * @param  {int} Angle  [description] 旋转角度
                 * @param {string} [Image] [description] 图片路径
                 * @return {[string]}  type [description] 返回图片名称
                 */
                rotateImage: function(Angle, Image) {
                    var ImageName = this.getFileName(Image);
                    var deffer = $q.defer();
                    if (Angle !== 0) {
                        Angle = Angle % 360;
                        Angle = Angle < 0 ? 360 + Angle : Angle;
                        var params = {
                            methodname: 'rotateImage',
                            serviceid: 'mlf_image',
                            Degree: Angle,
                            FileName: ImageName,
                            FileUrl: Image
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            deffer.resolve(data.FN);
                        });
                    } else {
                        deffer.resolve(ImageName);
                    }
                    return deffer.promise;
                },

                /**
                 * [isCbilionformRatio description] 判断gif图比例是否与预设比例相符
                 *
                 * @param  {[type]}  img   [img description] 图片对象
                 * @param  {[type]}  size   [size description] 预设比例, 逗号连接
                 * @param  {[type]}  type   [type description] 代表何种操作
                 *
                 * @return  {[type]}   [return description]
                 */
                isCbilionformRatio: function(img, size, type) {
                    type = type || '列表图';
                    var defer = $q.defer();
                    var sizeArr = size.split(',');
                    var imgAspectRatio = Number((sizeArr[0] / sizeArr[1]).toFixed(2));
                    if (Object.prototype.toString.call(img) === '[object String]') {
                        var src = img;
                        img = new Image();
                        img.src = src;
                        if (img.complate) {
                            dealAfterImg(img, imgAspectRatio, type, defer);
                        } else {
                            img.onload = function() {
                                dealAfterImg(img, imgAspectRatio, type, defer);
                            };
                        }
                    } else {
                        dealAfterImg(img, imgAspectRatio, type, defer);
                    }
                    return defer.promise;
                },

                /**
                 * [isGif description] 判断是否是gif图
                 *
                 * @param  {[type]}  src   [src description]
                 *
                 * @return  {[type]}   [return description]
                 */
                isGif: function(src) {
                    return this.getImageType(src) === 'gif';
                }
            };
        },
    ]);
